module.exports = "<div class=\"gw-tile\">\r\n    <div class=\"gw-tile-color\" ng-class=\"tileHeaderColor\"></div>\r\n    <div class=\"gw-tile-title\">{{tileTitle}}</div>\r\n    <div class=\"gw-tile-content\">{{tileValue}}\r\n        <i ng-class=\"tileIcon\" class=\"gw-icon fa\"></i>\r\n    </div>\r\n</div>        "


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/gateway/directives/TileDirective/tile.html
// module id = 759
// module chunks = 0